import PpToolPopover from '../ToolPopover';

import TypeSelection from './TypeSelection';
import PageTypeSelection from './PageTypeSelection';
import Item from './Item';

import {
  isEmpty,
  getDisplayBackgroundTypes,
  getDisplayBackgroundPageTypes,
  autoScroll
} from '@/common/utils';

export default {
  components: {
    PpToolPopover,
    Item,
    TypeSelection,
    PageTypeSelection
  },
  props: {
    backgroundTypes: {
      type: Object,
      default: () => ({})
    },
    backgrounds: {
      type: Array,
      default: () => []
    },
    selectedType: {
      type: Object,
      required: true
    },
    selectedPageType: {
      type: Object,
      required: true
    },
    appliedBackground: {
      type: Object,
      default: () => ({})
    },
    isPageTypeDisabled: {
      type: Boolean,
      default: false
    },
    isPageTypeHidden: {
      type: Boolean,
      default: false
    },
    isLoadingCategory: {
      type: Boolean,
      default: false
    },
    isLoadingBackgrounds: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      displayBackgroundPageType: getDisplayBackgroundPageTypes(),
      chosenBackground: {},
      noBackgroundLength: 4,
      isProduction: process.env.VUE_APP_PRODUCTION
    };
  },
  computed: {
    displayBackgroundTypes() {
      // Update for PP-2407
      const listBackgroundTypes = getDisplayBackgroundTypes(
        this.backgroundTypes
      );
      const listBackgroundFilter = listBackgroundTypes.filter(item => {
        return item.value !== 0;
      });
      if (this.isProduction) {
        return listBackgroundFilter;
      }
      return listBackgroundTypes;
    },
    selectedBackground() {
      if (!isEmpty(this.chosenBackground)) {
        return this.chosenBackground;
      }

      this.chosenBackground =
        this.backgrounds.length > 0 ? this.backgrounds[0] : { id: '' };

      return this.chosenBackground;
    }
  },

  mounted() {
    this.initData();
  },
  methods: {
    /**
     * Set up inital data to render in view
     */
    initData() {
      this.chosenBackground = {};
    },
    /**
     * Event fire when choose background type
     *
     * @param {Object}  data  data of chosen background type
     */
    onChangeBackgroundType(data) {
      this.$emit('typeChange', {
        value: data.value,
        sub: data.sub?.value
      });
      this.scrollToTop();
    },
    /**
     * Event fire when choose background page type
     *
     * @param {Object}  data  data of chosen background page type
     */
    onChangeBackgroundPageType(data) {
      this.$emit('pageTypeChange', data);
      this.scrollToTop();
    },
    /**
     * Event fire when choose background
     *
     * @param {Object}  data  data of chosen background
     */
    onSelectBackground(data) {
      this.chosenBackground = data;
    },
    /**
     * Close menu
     */
    onClose() {
      this.$emit('close');
    },
    /**
     * Trigger mutation to set Background
     */
    onApplyChosenBackground() {
      this.$emit('applyBackground', this.selectedBackground);

      this.onClose();
    },
    onLoadMoreCategory() {
      this.$emit('loadMoreCategory');
    },
    endIntersectBackgrounds(_, __, isIntersecting) {
      if (isIntersecting) {
        this.$emit('loadMoreBackgrounds');
      }
    },
    scrollToTop() {
      autoScroll(
        this.$refs,
        `background${this.appliedBackground?.id}`,
        this.$refs.container ? this.$refs.container.parentElement : null
      );
    }
  }
};
